{
  "header": "Entreprenør",
  "searchInputLabel": "Søk etter navn eller entreprenørnummer",
  "searchButton": "Søk",
  "table": {
    "columns": {
      "name": "Navn",
      "deactivated": "Deaktivert",
      "contractorNumber": "Entreprenørnummer",
      "location": "Sted",
      "office": "Kontor",
      "agreementType": "Avtale",
      "resources": "Ressurser",
      "type": "Type"
    },
    "deactivatedBadge": "Deaktivert",
    "resources": {
      "machines": "{{count}} maskiner",
      "crews": "{{count}} arbeidslag",
      "both": "{{machineCount}} maskiner, {{forestCrewCount}} arbeidslag"
    },
    "type": {
      "harvesting": "Hogst",
      "culture": "Skogkultur",
      "both": "Hogst & skogkultur",
      "noResources": "Mangler ressurs"
    }
  }
}
